<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Chapter-Title-Page-Break">The Discovery</p>
<p class="ORIM-Chapter-Opener-Paragraph">She moved to the basement, telling herself to remain calm. A sound. Movement. Somewhere ahead. Or was it her imagination? No more trying to beat the rush to the machines. She stopped, listened, looked around.</p>
<p class="ORIM-Body-Text">There was no one there. “Hello,” she said, as she moved slowly past the janitor’s dressing room.</p>
<p class="ORIM-Body-Text">A slight echo. But no answer. </p>
<p class="ORIM-Body-Text">“Is anyone here?”</p>
<p class="ORIM-Body-Text">Breathing. Waiting. And no reply.</p>
<p class="ORIM-Body-Text">Her legs seemed incapable of feeling, paralyzed. She walked down the corridor and stopped. There was a dark blotch in front of the garbage compactor room. Strangely, it seemed to be expanding.</p>
<p class="ORIM-Body-Text">Moving closer, she leaned over. It was blood—a trickle coming from under the door. She wanted to run for the elevator. But could she? Someone was certainly hurt, possibly caught in the compactor.</p>
<p class="ORIM-Body-Text">She jiggled the knob and opened the door; it was black inside.</p>
<p class="ORIM-Body-Text">“Is anyone in here?”</p>
<p class="ORIM-Body-Text">No reply. She fumbled for the light switch and flicked it on.</p>
<p class="ORIM-Body-Text">She looked ahead.</p>
<p class="ORIM-Body-Text">Then she screamed, her lungs seared by a blast of hot air, her skin shriveled on her body. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1-1.vue?73f7c5c1